const constantes = {

    RESPONSIVIDADE: {
        LARGURA_MOBILE: 1200
    },

    CORES: {
        VERDE_PRIMARIO: '#3A7F0D',
        AZUL_PRIMARIO: '#217373',

        ROXO_ABEA: '#3D2F66',
        AZUL_A2A2: '#29518D',
        COR_FAIR4THEM: '#8E008C',
        LARANJA_BEA: '#CD5A1C',
        VERDE_RPC: '#ACC435',

        MARROM_OVO_CAIPIRA: '#8B5C47',
        VERDE_PRODUCAO_SUSTENTAVEL: '#70AB41',
        DOURADO_DUROC: '#BC9C3D',

        BRANCO_PADRAO: 'white',
        PRETO_PADRAO: 'black',
        CINZA_PADRAO: 'grey',
        TRANSPARENTE: 'transparent',

        VERMELHO_PADRAO: '#E35252',
        VERDE_SUCESSO_PADRAO: '#58BF8E'
    },

}

export default constantes